import { Customizations } from 'models'

const vehicleSheetLabels: Customizations = {
  no: {
    label: 'Réf.int dossier: ',
    isDisplayed: true,
  },
  entityId: {
    label: 'Vendeur: ',
    isDisplayed: true,
  },
  referenceVendeur: {
    label: 'Réf. vendeur : ',
    isDisplayed: true,
  },
  licensePlate: {
    label: 'Immatriculation: ',
    isDisplayed: true,
  },
  vin: {
    label: 'VIN: ',
    isDisplayed: true,
  },
  dateFirstReg: {
    label: 'Date première immat.: ',
    isDisplayed: true,
  },
  color: {
    label: 'Couleur: ',
    isDisplayed: true,
  },
  typeRegDoc: {
    label: 'Type carte grise: ',
    isDisplayed: true,
  },
  bodyTypeRegDoc: {
    label: 'Type carrosserie: ',
    isDisplayed: true,
  },
  fuelType: {
    label: 'Type carburant: ',
    isDisplayed: true,
  },
  numberOfSeats: {
    label: 'Nb sièges: ',
    isDisplayed: true,
  },
  equipments: {
    label: 'Equipements: ',
    isDisplayed: true,
  },
  observationsVendeur: {
    label: 'Observations vendeur : ',
    isDisplayed: true,
  },
  noteExt: {
    label: 'Note extérieur : ',
    isDisplayed: true,
  },
  noteInt: {
    label: 'Note intérieur : ',
    isDisplayed: true,
  },
  noteCT: {
    label: 'Note technique : ',
    isDisplayed: true,
  },
  noteBilanExpert: {
    label: 'Note bilan expert : ',
    isDisplayed: true,
  },
  typeSpare: {
    label: 'Type roue de secours: ',
    isDisplayed: true,
  },
  make: {
    label: 'Marque: ',
    isDisplayed: true,
  },
  version: {
    label: 'Version: ',
    isDisplayed: true,
  },
  taxHp: {
    label: 'Puissance fisc: ',
    isDisplayed: true,
  },
  locationLocationName: {
    label: 'Lieu de stockage: ',
    isDisplayed: true,
  },
  providedMileage: {
    label: 'Kilométrage vendeur: ',
    isDisplayed: true,
  },
  providedFRE: {
    label: 'FRE: ',
    isDisplayed: true,
  },
  reserveTTCHF: {
    label: 'Prix de réserve (TTC HF) : ',
    isDisplayed: true,
  },
  mileage: {
    label: 'Kilométrage officiel: ',
    isDisplayed: true,
  },
  estimationApporteur: {
    label: 'Estimation: ',
    isDisplayed: true,
  },
  coteArgusKm: {
    label: 'Argus Kilo : ',
    isDisplayed: true,
  },
  coteArgusPriceDate: {
    label: 'Argus Mois : ',
    isDisplayed: true,
  },
  coteMarche: {
    label: 'Spot Price : ',
    isDisplayed: true,
  },
  auctionStatus: {
    label: 'Statut vente: ',
    isDisplayed: true,
  },
  administrativeStatus: {
    label: 'Statut admin: ',
    isDisplayed: true,
  },
}

export { vehicleSheetLabels }
